import * as React from 'react';

export function NotFound() {
  return (
    <div>
      <img src="https://webartdevelopers.com/blog/404-svg-animated-page-concept/"
        alt="404 not found" />

    </div>
  );
}
